/**
 * @file: description
 * @author:
 * @Date: 2020-03-23 09:36:07
 * @LastEditors:
 * @LastEditTime: 2020-03-24 17:34:41
 */
import { artModelState } from './artModel';
import { groupModelState } from './groupModel';
import { mallModelState } from './mallModel';
import { bannerModelState } from './bannerModel';
import { thematicModelState } from './thematicModel';

const initialState = {
  ...artModelState,
  groupModel: groupModelState,
  mallModel: mallModelState,
  bannerModel: bannerModelState,
  thematicModel: thematicModelState
};

export type IInitialState = Readonly<typeof initialState>;

export default initialState;
